import React, { useState } from 'react';

const ScreenshotCarousel = ({ images, alt = "App Screenshot" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  if (!images || images.length === 0) {
    return (
      <div className="bg-gray-100 rounded-2xl p-8 aspect-square flex items-center justify-center">
        <div className="text-center text-gray-500">
          <div className="text-sm">Screenshot Coming Soon</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4">
      {/* Previous Button */}
      {images.length > 1 && (
        <button
          onClick={goToPrevious}
          className="bg-white hover:bg-gray-50 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-saverly-primary flex-shrink-0"
          aria-label="Previous image"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      )}

      {/* Image Container */}
      <div className="relative bg-gray-900 rounded-2xl overflow-hidden shadow-2xl max-w-[320px] mx-auto">
        {/* Main Image Container */}
        <div className="relative aspect-[9/16]">
          <img
            src={images[currentIndex].src}
            alt={images[currentIndex].caption || alt}
            className="w-full h-full object-contain bg-gray-900"
          />

              {/* Caption */}
              {images[currentIndex].caption && (
                <div className="absolute top-0 left-0 right-0 bg-black/80 px-3 py-3 text-white z-10">
                  <p className="text-base font-semibold text-center">{images[currentIndex].caption}</p>
                </div>
              )}

              {/* Image Counter */}
              {images.length > 1 && (
                <div className="absolute top-14 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {currentIndex + 1} / {images.length}
                </div>
              )}

              {/* Dot Indicators */}
              {images.length > 1 && (
                <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex space-x-2 z-20">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white ${
                        index === currentIndex
                          ? 'bg-white w-6'
                          : 'bg-white/50 hover:bg-white/75'
                      }`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
            </div>
          )}
        </div>
      </div>

      {/* Next Button */}
      {images.length > 1 && (
        <button
          onClick={goToNext}
          className="bg-white hover:bg-gray-50 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-saverly-primary flex-shrink-0"
          aria-label="Next image"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ScreenshotCarousel;

